export const decodeHotelRoomConfig = configStr => {
	let resultArr = []
	typeof configStr === 'string' &&
		configStr.split('r').forEach(dataString => {
			let roomconfig = {}
			roomconfig.adultCount = +dataString[1]
			let childString = dataString.slice(2)
			let childAges = childString.split('c')
			childAges.shift()
			childAges.map(item => parseInt(item))
			roomconfig.childAges = childAges.filter(item => item)
			resultArr.push(roomconfig)
		})

	return resultArr
}
